<template>
    <ComponentBanner
        v-if="tourBanner.opened"
        position="footer"
        :lead="localizations[lang].onboarding.tourOfferLead"
        :text="localizations[lang].onboarding.tourOffer"
        :cta-label="localizations[lang].onboarding.tourCta"
        :auto-dismiss-ms="5000"
        cta-dusk="watchTour"
        @cta="startTour"
        @dismiss="closeTourBanner"
    />
</template>
<script>
import { mapMutations, mapState } from 'vuex';
import ComponentBanner from '_shared_/UI/Components/ComponentBanner.vue';

export default {
    name: 'ReaderTourBanner',
    components: { ComponentBanner },
    computed: {
        ...mapState(['tourBanner', 'localizations', 'lang']),
    },
    methods: {
        ...mapMutations(['openOnboarding', 'closeTourBanner']),
        startTour() {
            this.openOnboarding();
            this.closeTourBanner();
        },
    },
};
</script>
